import { render } from "./TrustStrip.vue?vue&type=template&id=38d5293e&scoped=true"
import script from "./TrustStrip.vue?vue&type=script&lang=js"
export * from "./TrustStrip.vue?vue&type=script&lang=js"

import "./TrustStrip.vue?vue&type=style&index=0&id=38d5293e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d5293e"]])

export default __exports__